<!--
Voting confirmation screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav name="Confirmation" :back="false" :home="true"/>
  <div class="vContainer">
      <img src="@/assets/voteEnd.svg" id="voteEndImg2"/>
      <p id="votingSubmitHdr">Thanks</p>
      <p id="votingSubmitMsg">
        We have got your vote for the <strong>{{values[1]}}</strong> election.
      </p>

      <router-link to="/voting/election" class="list-group-item" id="votingBack2" tabindex="0">
        Back to elections
      </router-link>
    </div>
  </div>
</template>

<script setup>
//Utilities
import axios from 'axios'
import { ref, onMounted } from 'vue'

//Data
const values = ref({})

onMounted(
  () => {
    axios.get('/vote/rest/confirm')
      .then(response => {
        values.value = {}
        values.value = response.data
      })
  }
)

</script>

<style>
#votingBack2 {
  border: 1px solid var(--uog-dark-blue);
  background-color: var(--uog-dark-blue);
  color:#ffffff;
  font-weight:700;
  border-radius:12px;
  text-align:center;
}

#votingSubmitHdr {

  font-weight: bold;
  font-size: 25px;
  text-align:center;
  color: var(--uog-dark-blue);
}

#votingSubmitMsg {
  text-align:center;
  color:#4F5961;
}

#voteEndImg2 {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top:64px;
  margin-bottom:36px;
}
</style>
